import React from 'react';
import YoutubeVideoDuration from '~/components/containers/YoutubePlaylistContainer/data/YoutubeVideoDuration';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';

interface VideoDurationProps {
  duration: YoutubeVideoDuration;
}

const VideoDuration: React.FC<VideoDurationProps> = ({ duration }) => {
  if (duration === null) {
    return null;
  }

  const mmssString = `${duration.minutes.padStart(
    2,
    '0'
  )}:${duration.seconds.padStart(2, '0')}`;

  return (
    <div className="VideoDuration">
      <FormattedMessageWrapper
        langKey="web.youtube_playlist.video_length"
        values={{ videoLength: mmssString }}
      />
    </div>
  );
};

export default VideoDuration;
